<accordion
    [isOpen]="isOpen"
    class="shopping-cart-accordion"
    [ngClass]="{ 'shopping-cart-accordion-parent': isParent }"
    (toggleStatus)="toggle()"
>
    <div fcp-accordion-header-content *ngIf="displayMode === DisplayMode.Desktop">
        <div class="shopping-cart-accordion-content">
            <div
                class="shopping-cart-accordion-content-title fcp-text-body-m"
                [class.shopping-cart-accordion-content-title-no-image]="!image"
            >
                <fcp-icon *ngIf="icon" [icon]="icon" class="shopping-cart-accordion-content-icon"></fcp-icon>
                <img *ngIf="image" [src]="image" class="shopping-cart-accordion-content-image" />
                <span>{{ title }}</span>
            </div>

            <div class="shopping-cart-accordion-content-values">
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-info">{{ itemInfo.articles }}</div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-info">{{ itemInfo.quantity }}</div>
                <div
                    *ngIf="itemInfo"
                    class="shopping-cart-accordion-content-info"
                    (mouseenter)="isTooltipVisible.next(true)"
                    (mouseleave)="isTooltipVisible.next(false)"
                >
                    <span cdkOverlayOrigin #bodyCell="cdkOverlayOrigin">
                        {{ itemInfo.rrp }}
                    </span>
                    <fcp-tooltip
                        *ngIf="itemInfo.rrp === '--'"
                        [open]="isTooltipVisible | async"
                        [overlayOrigin]="bodyCell"
                        [customPosition]="tooltipPosition"
                    >
                        {{ 'ORDER.SHOPPING_CART.MULTIPLE_CURRENCY_TOOLTIP' | translate }}
                    </fcp-tooltip>
                </div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-info">{{ itemInfo.pp }}</div>
            </div>
        </div>
        <ng-container *ngIf="alertMessages">
            <ng-container *ngFor="let alertMessage of alertMessages">
                <div *ngIf="alertMessage" class="shopping-cart-accordion-content-alert">
                    <fcp-alert type="info" size="large">
                        <ng-container
                            *ngTemplateOutlet="alertMessageContent; context: { $implicit: alertMessage }"
                        ></ng-container>
                    </fcp-alert>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <div fcp-accordion-header-content *ngIf="displayMode === DisplayMode.Mobile">
        <div class="shopping-cart-accordion-content-mobile">
            <div class="shopping-cart-accordion-content-title fcp-text-body-m">
                <fcp-icon *ngIf="icon" [icon]="icon" class="shopping-cart-accordion-content-icon"></fcp-icon>
                <img *ngIf="image" [src]="image" class="shopping-cart-accordion-content-image" />
                <span>{{ title }}</span>
            </div>

            <ng-container *ngIf="alertMessages">
                <ng-container *ngFor="let alertMessage of alertMessages">
                    <div *ngIf="alertMessage" class="shopping-cart-accordion-content-mobile-alert">
                        <span class="shopping-cart-accordion-content-mobile-alert-text">
                            <ng-container
                                *ngTemplateOutlet="alertMessageContent; context: { $implicit: alertMessage }"
                            ></ng-container>
                        </span>
                    </div>
                </ng-container>
            </ng-container>

            <div class="shopping-cart-accordion-content-mobile-values">
                <div class="shopping-cart-text-bold">{{ 'ORDER.PRODUCT_DETAILS.SUMMARY' | translate }}</div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-mobile-info">
                    {{ 'ORDER.PRODUCT_DETAILS.TOTAL_ARTICLES' | translate }}:
                    <div class="shopping-cart-text-bold">{{ itemInfo.articles }}</div>
                </div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-mobile-info">
                    {{ 'ORDER.PRODUCT_DETAILS.TOTAL_ITEMS' | translate }}:
                    <div class="shopping-cart-text-bold">{{ itemInfo.quantity }}</div>
                </div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-mobile-info">
                    {{ 'ORDER.PRODUCT_DETAILS.TOTAL_RRP' | translate }}:
                    <div
                        class="shopping-cart-text-bold"
                        (mouseenter)="isTooltipVisible.next(true)"
                        (mouseleave)="isTooltipVisible.next(false)"
                    >
                        <span cdkOverlayOrigin #bodyCell="cdkOverlayOrigin">
                            {{ itemInfo.rrp }}
                        </span>
                        <fcp-tooltip
                            *ngIf="itemInfo.rrp === '--'"
                            [open]="isTooltipVisible | async"
                            [overlayOrigin]="bodyCell"
                            [customPosition]="tooltipPosition"
                        >
                            {{ 'ORDER.SHOPPING_CART.MULTIPLE_CURRENCY_TOOLTIP' | translate }}
                        </fcp-tooltip>
                    </div>
                </div>
                <div *ngIf="itemInfo" class="shopping-cart-accordion-content-mobile-info">
                    {{ 'ORDER.PRODUCT_DETAILS.TOTAL_PP' | translate }}:
                    <div class="shopping-cart-text-bold">{{ itemInfo.pp }}</div>
                </div>
            </div>
        </div>
    </div>

    <div fcp-accordion-content class="shopping-cart-accordion-body">
        <ng-content></ng-content>
    </div>
</accordion>

<ng-template #alertMessageContent let-alertMessage>
    @if (isLinkAlert(alertMessage)) {
        {{ alertMessage.text }}
        <a fcp-link href (click)="handleLinkClick($event, alertMessage.url)">
            {{ 'ORDER.SHOPPING_CART.TERMS_AND_CONDITIONS.LINK' | translate }}
        </a>
    } @else {
        <span>{{ alertMessage }}</span>
    }
</ng-template>
